export function hideSectionsOnBacklink() {
  const urlParams = new URLSearchParams(window.location.search);
  const isMarketplaceBacklink =
    urlParams.has('utm_medium') &&
    urlParams.get('utm_medium') === 'referral' &&
    urlParams.has('utm_source') &&
    urlParams.has('utm_campaign') &&
    urlParams.get('utm_campaign') === 'marketplace_backlink';

  if (isMarketplaceBacklink) {
    document.querySelectorAll('.js-delete-on-backlink').forEach(el => el.remove());
    document.querySelectorAll('.js-hide-on-backlink').forEach(el => el.classList.add('hidden'));
  }
}
